export const parseFloatValue = (strValue: string) => Number(strValue?.replace(',', '.'));
